import React from 'react';
import { CTAButton } from './CTAButton';
const MentorshipIcon = () => <svg viewBox="0 0 120 120" fill="none" className="w-24 h-24 mx-auto drop-shadow-[0_0_15px_rgba(34,197,94,0.6)]" data-id="element-26">
    <rect x="10" y="25" width="100" height="70" rx="8" stroke="#22c55e" strokeWidth="4" fill="none" data-id="element-27" />
    <circle cx="45" cy="52" r="10" stroke="#22c55e" strokeWidth="3" fill="none" data-id="element-28" />
    <path d="M30 75c0-8 6.7-15 15-15s15 7 15 15" stroke="#22c55e" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-29" />
    <circle cx="80" cy="48" r="8" stroke="#22c55e" strokeWidth="3" fill="none" data-id="element-30" />
    <path d="M68 68c0-6.6 5.4-12 12-12s12 5.4 12 12" stroke="#22c55e" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-31" />
    <circle cx="60" cy="12" r="5" fill="#22c55e" data-id="element-32" />
    <path d="M50 8h20" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" data-id="element-33" />
  </svg>;
const bonuses = [{
  title: 'Mentoría grupal semanal en vivo',
  description: 'Acompañamiento real para que no te quedes trabado solo.',
  emoji: null,
  useSvg: true
}, {
  title: 'Prompts de IA para contenido y anuncios',
  description: 'Para acelerar ideas, copies, hooks y ejecución.',
  emoji: '🤖',
  useSvg: false
}, {
  title: 'Checklist completa de lanzamiento',
  description: 'Para que no se te escape ningún paso importante.',
  emoji: '✅',
  useSvg: false
}, {
  title: 'Estructura base de landing',
  description: 'Para que puedas armar una página simple y funcional para vender.',
  emoji: '🖥️',
  useSvg: false
}, {
  title: 'Plantillas de copy para ventas',
  description: 'Para comunicar mejor tu oferta y vender con más claridad.',
  emoji: '✍️',
  useSvg: false
}];
export function BonusesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#9C16A3] py-8 md:py-12 px-4" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <div className="inline-block bg-yellow-400 px-8 py-3 rounded-full font-black text-xl mb-6 text-[#9C16A3]" data-id="element-37">
            🎁 BONUS DE REGALO
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-[#FFFFFF]" data-id="element-38">
            ACCEDÉ AHORA Y LLEVATE TODO 🎁
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-39">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-300 border-4 border-[#b026ff] shadow-[0_0_15px_rgba(176,38,255,0.5),0_0_30px_rgba(176,38,255,0.3)]" onClick={scrollToCompra} data-id="element-40">
              <div className="flex justify-center -mb-3 relative z-10 pt-4" data-id="element-41">
                <div className="bg-green-500 text-white px-5 py-2 rounded-full font-black text-sm tracking-wide shadow-[0_0_15px_rgba(34,197,94,0.6),0_0_30px_rgba(34,197,94,0.3)] animate-bounce" data-id="element-42">
                  🎁 GRATIS POR HOY
                </div>
              </div>
              <div className="px-4 py-8 flex flex-col items-center justify-center min-h-[200px]" data-id="element-43">
                <div className="text-green-500 font-black text-5xl mb-3 drop-shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-44">
                  #{index + 1}
                </div>
                {bonus.useSvg ? <MentorshipIcon data-id="element-45" /> : <span className="text-7xl drop-shadow-[0_0_15px_rgba(34,197,94,0.6)]" data-id="element-46">
                    {bonus.emoji}
                  </span>}
              </div>
              <div className="p-6" data-id="element-47">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-48">
                  Bono {index + 1} — {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-49">{bonus.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}